import request from '@/utils/request'

/**
 * 获取积分设置列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listIntegralSetting(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/integral.listIntegralSetting',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新积分设置
 * @param {Object} data 更新数据
 * @returns {Promise} Promise对象
 */
export function updateIntegralSetting(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/integral.updateIntegralSetting',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg))
      }
    }).catch(error => {
      reject(error)
    })
  })
}